module.exports = [
    {
        title: "Office Meeting",
        description: "Currently busy",
        className: "bg-color-darken txt-color-white",
        icon: "fa-time"
    },
    {
        title: "Lunch Break",
        description: "No Description",
        className: "bg-color-blue txt-color-white",
        icon: "fa-pie"
    },
    {
        title: "URGENT",
        description: "urgent tasks",
        className: "bg-color-red txt-color-white",
        icon: "fa-alert"
    }
];
